import { isProd } from "utils-lib/builds"

const recaptchaSiteKeys = {
  PROD: "6LelVjsiAAAAAPAnYkDotkEt1T4An7b3yuV3AJrV",
  NON_PROD: "6Ld3OKohAAAAAGfNvLUgKd-_YwhE5qxYBSDXmsr0",
}

/**
 * Retrieves the reCAPTCHA configuration based on the current environment.
 * @returns {string} The reCAPTCHA configuration key.
 */
const getReCaptchaConfig = () => {
  if (!isProd()) {
    return recaptchaSiteKeys.NON_PROD
  }
  return recaptchaSiteKeys.PROD
}

export default getReCaptchaConfig
